import { Signatory } from '../../../shared/domain/place/model/Signatory';
import { isEmailValid } from '../../components/Form/utils/validator/emailValidator';

const isSignatoryComplete = ({ firstName, lastName, email }: Signatory): boolean =>
  firstName !== '' && lastName !== '' && isEmailValid(email);

export default isSignatoryComplete;
